	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Material.Material;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-fundamental/ref/Material/Material.js
// module id = 20
// module chunks = 0